import type { TModule } from '@modules/core/types';

import { FINANCE_ROUTE_PATHS } from './config';
import { EXPATRIATIONS_ROUTES } from './expatriations';
import { FEE_RULES_ROUTES } from './fee-rules';

const financeModule: TModule = {
  id: 'finance',
  fallbackRoute: [FINANCE_ROUTE_PATHS.feeRules],
  permissions: { roles: [] },
  isPublic: false,
  routes: [...FEE_RULES_ROUTES, ...EXPATRIATIONS_ROUTES],
};

export { FINANCE_ROUTE_PATHS as FinanceRoutePaths };

export default financeModule;
